import {CartSidebar} from 'modules/Cart/components/CartSidebar/CartSidebar';
import {useCartSidebar} from 'modules/Cart/hooks/useCartSidebar';
import {FC} from 'react';

type Props = {
    className?: string;
    isSubmittedMode?: boolean;
};
export const OrderCartSidebar: FC<Props> = ({className, isSubmittedMode}) => {
    const {
        total,
        regionalDiscounts,
        handleSubmit,
        handleCallback,
        submitButtonIsDisabled,
        priceIsTooLow,
        minimalPrice,
        step,
        formSubmitCount,
        orderFormIsValid,
    } = useCartSidebar();

    return (
        <CartSidebar
            className={className}
            productsTypeAmount={total.productsTypeAmount}
            totalProductsAmount={total.productsAmount}
            totalPriceOfProducts={total.price}
            totalPrice={total.totalPrice}
            totalDiscount={total.discount}
            minimalPrice={minimalPrice}
            regionalDiscounts={regionalDiscounts}
            cartHasRegionalDiscount={total.cartHasRegionalDiscount}
            isSubmittedMode={isSubmittedMode}
            submitButtonIsDisabled={submitButtonIsDisabled}
            priceIsTooLow={priceIsTooLow}
            shouldShowFormError={Boolean(formSubmitCount && !orderFormIsValid)}
            step={step}
            handleSubmit={handleSubmit}
            handleCallback={handleCallback}
        />
    );
};
